// Unpublished Work © 2021-2022 Deere & Company

const serializedParams = (params) =>
    Object.keys(params)
        .filter((key) => params[key] !== '')
        .map((key) => `${key}=${params[key]}`)
        .join('&');

const hasOtherQueryParams = (api) => /\?/.test(api);

export const appendParamsToEndpoint = (api, params) => {
    const queryParams = serializedParams(params);

    if (Object.keys(queryParams).length === 0) {
        return api;
    }

    const querySymbol = hasOtherQueryParams(api) ? '&' : '?';

    return `${api}${querySymbol}${queryParams}`;
};
